export default "__VITE_ASSET__Cc48oH02__"